import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  TranslateModule,
  // TranslateLoader,
} from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LogoComponent } from './svg/logo/logo.component';
import { ControlInputPasswordComponent } from './component/control-input-password/control-input-password.component';
import { ControlResendCodeComponent } from '../auth/shared/component/control-resend-code/control-resend-code.component';
import { IconDirective } from '@coreui/icons-angular';
import { toSnakeCase } from './utils/string-case-manipulation';
import {
  ButtonDirective,
  AlertComponent,
  FormSelectDirective,
  SpinnerComponent,
  InputGroupComponent,
  ColComponent,
  ContainerComponent,
  RowComponent,
  ModalComponent,
  ModalHeaderComponent,
  ModalBodyComponent,
  CalloutComponent,
  ModalFooterComponent,
  ButtonCloseDirective,
  ModalTitleDirective,
} from '@coreui/angular-pro';
import { AlertConfirmationComponent } from '../auth/shared/component/alert-confirmation/alert-confirmation.component';
import { AlertMessageComponent } from '../auth/shared/component/alert-message/alert-message.component';
import { FormHeaderComponent } from '../auth/shared/component/form-header/form-header.component';
import { ControlButtonSubmitComponent } from '../auth/shared/component/control-button-submit/control-button-submit.component';
import { ControlInputUserComponent } from './component/control-input-user/control-input-user.component';
import { MfaSettingsModalComponent } from '../auth/component/mfa-settings-modal/mfa-settings-modal.component';
import { ENVIRONMENT } from '../../environments/environment';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(
    http,
    ENVIRONMENT.STATIC_LOCATION + ENVIRONMENT.TRANSLATIONS_LOCATION,
    `.json?v=${ENVIRONMENT.VERSION}`,
  );
}

@NgModule({
  declarations: [
    AlertConfirmationComponent,
    AlertMessageComponent,
    ControlButtonSubmitComponent,
    ControlInputPasswordComponent,
    ControlInputUserComponent,
    ControlResendCodeComponent,
    MfaSettingsModalComponent,
    FormHeaderComponent,
    // LogoComponent
  ],
  // TranslateModule.forRoot({
  //     loader: {
  //       provide: TranslateLoader,
  //       useFactory: HttpLoaderFactory,
  //       deps: [HttpClient],
  //     },
  //   }),
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    AlertComponent,
    ButtonDirective,
    FormSelectDirective,
    IconDirective,
    InputGroupComponent,
    SpinnerComponent,
    ContainerComponent,
    ColComponent,
    RowComponent,
    ModalComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    CalloutComponent,
    ModalFooterComponent,
    ButtonCloseDirective,
    ModalTitleDirective,
    LogoComponent,
  ],
  exports: [
    TranslateModule,
    AlertConfirmationComponent,
    AlertMessageComponent,
    CommonModule,
    ControlButtonSubmitComponent,
    ControlInputPasswordComponent,
    ControlInputUserComponent,
    ControlResendCodeComponent,
    MfaSettingsModalComponent,
    FormHeaderComponent,
    LogoComponent,
    ReactiveFormsModule,
  ],
})
export class SharedModule {
  static toSnakeCase = toSnakeCase;
}
